import { useMutation } from '@tanstack/react-query'
import { useApiClientDocument } from '~/@api/client/useApiClientDocument'
import type { IAccountAppFilePdfDownloadRequest } from '~/@api/generated-api-types-document/Api'
import { downloadPDF } from '~/@lib/utils/files.utils'

// Download PDF dokumentov z portfólia — POST /document/pdf/download (document doc).
// Legacy Meteor súbory sú na Nest storage zmigrované, teda ich download funguje rovnako.
function useAppfilePdfDownload() {
  const client = useApiClientDocument()

  const downloadFileMutation = useMutation({
    mutationFn: (params: IAccountAppFilePdfDownloadRequest) => {
      return downloadFile(params)
    },
  })

  async function downloadFile(params: IAccountAppFilePdfDownloadRequest) {
    const { data } = await client.document.appFilesControllerDownloadPdf(
      params,
      { secure: true }
    )
    downloadPDF(data.data.file, data.data.filename)
  }

  return {
    downloadFile: downloadFileMutation.mutate,
    isDownloadingFileId: downloadFileMutation.isPending
      ? (downloadFileMutation.variables?.fileId ?? null)
      : null,
    error: downloadFileMutation.error,
    handleReset: downloadFileMutation.reset,
  }
}

export { useAppfilePdfDownload }
